export const Chromium = {
  mounted() {
    const isChromium = !!window.chrome;
    if (!isChromium) {
      this.el.classList.remove("hidden");
    }
  },
};
